module.exports = "https://cdn.dove.it/_next/static/public/assets/services/servizi-consulenza.fdb7c2b28bce39832bb35bce7d7f5a47.jpg";